function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Bitstream Vera Sans"
    },
    d: "M 15 5 L 15 15 L 5 15 L 5 17 L 15 17 L 15 27 L 17 27 L 17 17 L 27 17 L 27 15 L 17 15 L 17 5 L 15 5 z",
    color: "#000",
    overflow: "visible",
    fontFamily: "Bitstream Vera Sans"
  }));
};

export default __webpack_public_path__ + "static/media/plus-math.43b835ee.svg";
export { SvgComponent as ReactComponent };